import css from "./lesson.module.css";
import settingLesson from "../../img/settingLesson.png";
import shareLesson from "../../img/shareLesson.png";
import heartLesson from "../../img/heartLesson.png";
import infoLesson from "../../img/infoLesson.png";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import {
  getLanguageLevelById,
  getLanguageLevels,
} from "../../lib/getLanguageLevels";
import { getVideoCategories } from "../../lib/videoCategoryApi";
import signalLesson from "../../img/signalLesson.png";
import videoMarketing from "../../img/videoMarketing.png";
import Question from "./question";
import FavoriteButton from "./favoriteButton";
import cursingds from "../../img/cursingds.png";
import discussgif from "../../img/discussgif.gif";
import discusspngD from "../../img/discusspngD.png";
import wiredoutlinephoto from "../../img/wiredoutlinephoto.png";
import wiredoutlinegit from "../../img/wired-outlinegit.gif";
import learnpngd from "../../img/learnpngd.png";
import learngif from "../../img/learngif.gif";
import watchVideoPng from '../../img/watch-lesson.png';
import openBookPng from '../../img/open-book.png';
import knowlagePng from '../../img/knowledge.png';
import discussPng from '../../img/discussion.png';
import dictionary from '../../img/dictionary.png';
import like from '../../img/like.png';
import likeOff from '../../img/likeOff.png';
import { toggleVideoFavorite, getFavoriteStatus } from '../../lib/favoriteApi';
const levelOrder = ["A1", "A2", "B1", "B2", "C1", "C2", "pre-A1"];
const levelMapping = {
  A1: {
    fullName: "Beginner",
    order: 1,
    bgColor: "#e8f5e9",
    textColor: "#2e7d32",
    name: "A1",
  },
  A2: {
    fullName: "Elementary",
    order: 2,
    bgColor: "#fff3e0",
    textColor: "#f57c00",
    name: "A2",
  },
  B1: {
    fullName: "Intermediate",
    order: 3,
    bgColor: "#e3f2fd",
    textColor: "#1565c0",
    name: "B1",
  },
  B2: {
    fullName: "Upper-Intermediate",
    order: 4,
    bgColor: "#ede7f6",
    textColor: "#673ab7",
    name: "B2",
  },
  C1: {
    fullName: "Advanced",
    order: 5,
    bgColor: "#ffebee",
    textColor: "#d32f2f",
    name: "C1",
  },
  C2: {
    fullName: "Proficiency",
    order: 6,
    bgColor: "#fce4ec",
    textColor: "#c2185b",
    name: "C2",
  },
  "pre-A1": {
    fullName: "Pre-Beginner",
    order: 0,
    bgColor: "#c8e6c9",
    textColor: "#1b5e20",
    name: "pre-A1",
  }
};
const LessonInfo = ({
  lesson,
  setLearnWords,
  setVideoP,
  setSelectedButton,
  selectedButton,
  setVideoQ,
  videoQ,
  handleSelect,
  dialogues,
  setDialogues,
  isCompletionShown
}) => {
  const { t } = useTranslation();
  const [categories, setCategories] = useState([]);
  const [isLiked, setIsLiked] = useState(false);
  const [favoriteId, setFavoriteId] = useState(null);
  const [languageLevel, setLanguageLevel] = useState("");
  const [levels, setLevels] = useState([]);
  const [isTogglingFavorite, setIsTogglingFavorite] = useState(false);

  const seeVideo = () => {
    setVideoP(true);
    setLearnWords(false);
  };
  
  const learnW = () => {
    setVideoP(false);
    setLearnWords(true);
    setDialogues(false);
    setSelectedButton("learn");
    setVideoQ(false);
    
    // Update active state for buttons
    updateActiveButton(1); // Second button (Study Words)
  };

  const [levelStyles, setLevelStyles] = useState({
    bgColor: "#e0e0e0",
    textColor: "#000",
    fullName: "Unknown Level",
    order: "-",
  });
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const categoriesData = await getVideoCategories();
        setCategories(categoriesData.results);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    const fetchLevels = async () => {
      try {
        const levelsData = await getLanguageLevels();
        const adaptedLevels = levelOrder
          .map((key) => levelsData.results.find((level) => level.name === key))
          .filter(Boolean)
          .map((level) => ({
            id: String(level.id),
            name: levelMapping[level.name] || level.name,
          }));
        setLevels([{ id: "all", name: "All levels" }, ...adaptedLevels]);
      } catch (error) {
        console.error("Error fetching levels:", error);
      }
    };

    fetchCategories();
    fetchLevels();
  }, []);

  // Set default active state for "Watch Video" on component mount
  useEffect(() => {
    const firstChoiceWrap = document.querySelector(`.${css.choiceWrap}`);
    if (firstChoiceWrap) {
      firstChoiceWrap.classList.add(css.active);
    }
  }, []);
  const showVideo = () => {
    setVideoP(true);
    setLearnWords(false);
    setVideoQ(false);
    setDialogues(false);
    setSelectedButton("none");
    
    // Update active state for buttons
    updateActiveButton(0); // First button (Watch Video)
  };

  const showQuestions = () => {
    setVideoP(false);
    setLearnWords(false);
    setSelectedButton("discuss");
    setDialogues(false);
    setVideoQ(true);
    
    // Update active state for buttons
    updateActiveButton(2); // Third button (Check Understanding)
  };

  const showDialogues = () => {
    setVideoP(false);
    setLearnWords(false);
    setSelectedButton("none");
    setVideoQ(false);
    setDialogues(true);
    
    // Update active state for buttons
    updateActiveButton(3); // Fourth button (Practice Dialogues)
  };

  // Helper function to update active button state
  const updateActiveButton = (index) => {
    const choiceWraps = document.querySelectorAll(`.${css.choiceWrap}`);
    choiceWraps.forEach((el, i) => {
      if (i === index) {
        el.classList.add(css.active);
      } else {
        el.classList.remove(css.active);
      }
    });
  };

  useEffect(() => {
    const fetchLanguageLevel = async () => {
      try {
        const level = await getLanguageLevelById(lesson.video.languageLevel);

        setLanguageLevel(level.name);
        if (levelMapping[level.name]) {
          setLevelStyles(levelMapping[level.name]);
        }
      } catch (error) {
        console.error("Error fetching language level:", error);
      }
    };

    if (lesson) {
      console.log("Lesson data loaded:", lesson);
      fetchLanguageLevel();

      // Fetch favorite status from API since lesson data might not include it
      const fetchFavoriteStatus = async () => {
        try {
          const { isFavorited, favoriteId: favoriteIdValue } = await getFavoriteStatus(lesson.id);

          setIsLiked(isFavorited);
          setFavoriteId(favoriteIdValue);

          console.log('Lesson favorite status loaded:', { lessonId: lesson.id, isFavorited });
        } catch (error) {
          console.error('Error fetching favorite status:', error);
          // Fallback to lesson data if API call fails
          const isFavorited = lesson.is_favorited || false;
          const favoriteIdValue = lesson.favorite_id || null;
          setIsLiked(isFavorited);
          setFavoriteId(favoriteIdValue);
        }
      };

      fetchFavoriteStatus();
    }
  }, [lesson]);
  const getCategoryIcon = (categoryId) => {
    const parentCategory = findParentCategory(categoryId);
    if (!parentCategory) return '🌐';

    const name = parentCategory.name?.toLowerCase() || '';
    
    // Check for more specific categories first (order matters!)
    if (name.includes('talk') || name.includes('dialogue') || name.includes('діалог') || name.includes('розмов') || name.includes('спілкування') || name.includes('rozmawiać') || name.includes('dialog') || name.includes('socializ')) return '🗣️';
    if (name.includes('all') || name.includes('всі') || name.includes('wszystkie')) return '🌐';
    if (name.includes('travel') || name.includes('подорож') || name.includes('podróż')) return '✈️';
    if (name.includes('work') || name.includes('робот') || name.includes('praca') || name.includes('business') || name.includes('бізнес')) return '💼';
    if (name.includes('education') || name.includes('освіт') || name.includes('edukacja') || name.includes('learn')) return '📚';
    if (name.includes('health') || name.includes('здоров') || name.includes('zdrowie')) return '❤️';
    if (name.includes('news') || name.includes('новин') || name.includes('wiadomości') || name.includes('tech') || name.includes('технолог')) return '📱';
    if (name.includes('leisure') || name.includes('дозвілля') || name.includes('rozrywka') || name.includes('entertainment') || name.includes('розваг')) return '🎮';
    if (name.includes('daily') || name.includes('щоден') || name.includes('codzienn')) return '📅';

    return '🌐';
  };

  const findParentCategory = (categoryId) => {
    const category = categories.find(cat => cat.id === categoryId);
    if (!category) return null;
    
    if (category.parent === null) {
      return category;
    }
    
    return categories.find(cat => cat.id === category.parent);
  };

  const getCategoryName = (categoryId) => {
    const category = categories.find((cat) => cat.id === categoryId);
    return category ? category.name : "Unknown Category";
  };

  const handleFavoriteToggle = async () => {
    if (isTogglingFavorite) return; // Prevent multiple clicks
    setIsTogglingFavorite(true);

    // Store previous state for rollback
    const previousIsLiked = isLiked;
    const previousFavoriteId = favoriteId;

    // Optimistic update
    setIsLiked(!isLiked);

    try {
      const response = await toggleVideoFavorite(lesson.id, favoriteId, isLiked);

      if (!isLiked) {
        // Adding to favorites - response should contain the new favorite ID
        setFavoriteId(response.id);
        console.log('Added to favorites with ID:', response.id);
      } else {
        // Removing from favorites
        setFavoriteId(null);
        console.log('Removed from favorites');
      }

      console.log('Favorite status updated successfully');
    } catch (error) {
      console.error('Error toggling favorite:', error);
      // Revert optimistic update on error
      setIsLiked(previousIsLiked);
      setFavoriteId(previousFavoriteId);
      // Show user-friendly error message
      alert(t('Failed to update favorite status. Please try again.'));
    } finally {
      setIsTogglingFavorite(false);
    }
  };
  return (
    <div className={css.lessonInfoWrap}>
      <div className={css.generalInfo}>
        <div className={css.levelWrap}>
          <p className={css.forWho} style={{ backgroundColor: levelStyles.textColor }}>
            {t(levelStyles.fullName)}
          </p>
        </div>
      <div className={css.nameLessonWrap}>
        <div className={css.nameWr}>
          <div className={css.logoTopText}>
            <h1 className={css.lessonName}>{lesson.video.name}</h1>
            <div
              className={css.favoriteBadge}
              onClick={handleFavoriteToggle}
              style={{
                cursor: isTogglingFavorite ? 'wait' : 'pointer',
                opacity: isTogglingFavorite ? 0.6 : 1
              }}
            >
              {isLiked ?
                <img src={like} alt="liked" /> :
                <img src={likeOff} alt="not liked" />
              }
            </div>
          </div>
        </div>
        <div className={css.wrapIconName}>
          {/* <img src={settingLesson} className={css.settingLesson} alt="icon" />
          <img src={shareLesson} className={css.settingLesson} alt="icon" /> */}
          {/* <FavoriteButton lessonId={lesson.id} /> */}
          {/* <img src={heartLesson} className={css.settingLesson} alt="icon" /> */}
          {/* <img src={infoLesson} className={css.settingLesson} alt="icon" /> */}
        </div>
      </div>

      <div className={css.goLiveWrap}>
        <div className={css.wrapLevelsAndCat}>
         {/* <p
            className={css.countLevel}
            style={{
              backgroundColor: levelStyles.textColor,
            }}
          > 
            {levelStyles.name}
          </p>*/}
          <p className={css.lessonsCategory}>
            {getCategoryIcon(lesson.video.category)} {getCategoryName(lesson.video.category)}
          </p>
        </div>
        {/* <div className={css.goLiveButton}>
          Go live{" "}
          <img src={signalLesson} className={css.signalLesson} alt="icon" />
        </div> */}
      </div>
      </div>

      <div className={css.trainSwitch}>
      <div 
        className={css.choiceWrap} 
        data-choice-index="0"
        onClick={(e) => {
          if (isCompletionShown) return; // Disable when completion is shown
          document.querySelectorAll(`.${css.choiceWrap}`).forEach(el => el.classList.remove(css.active));
          e.currentTarget.classList.add(css.active);
          showVideo()
        }}
        style={{ 
          opacity: isCompletionShown ? 0.5 : 1, 
          cursor: isCompletionShown ? 'not-allowed' : 'pointer',
          pointerEvents: isCompletionShown ? 'none' : 'auto'
        }}
      >
        {/* <img
          className={css.videoMarketing}
          src={watchVideoPng}
          alt="icon"
        />*/}
        <div className={css.choiceIcon}>▶</div>
        <div className={css.choiceInfo}>
          <p className={css.textInChoice}>{t("Watch Video")}</p>
          <p className={css.textInChoiceDesc}>{t("Watch the full lesson video")}</p>
        </div>
      </div>

      <div 
        className={css.choiceWrap} 
        data-choice-index="1"
        onClick={(e) => {
          if (isCompletionShown) return; // Disable when completion is shown
          document.querySelectorAll(`.${css.choiceWrap}`).forEach(el => el.classList.remove(css.active));
          e.currentTarget.classList.add(css.active);
          learnW();
        }}
        style={{ 
          opacity: isCompletionShown ? 0.5 : 1, 
          cursor: isCompletionShown ? 'not-allowed' : 'pointer',
          pointerEvents: isCompletionShown ? 'none' : 'auto'
        }}
      >
        {/*<img
          className={css.videoMarketing}
          src={openBook}
          alt="icon"
        />*/}
        <div className={css.choiceIcon}>📖</div>
        <div className={css.choiceInfo}>
          <p className={css.textInChoice}>{t("Study Words")}</p>
          <p className={css.textInChoiceDesc}>{t("Learn vocabulary in context")}</p>
        </div>
      </div>

      <div 
        className={css.choiceWrap} 
        data-choice-index="2"
        onClick={(e) => {
          if (isCompletionShown) return; // Disable when completion is shown
          document.querySelectorAll(`.${css.choiceWrap}`).forEach(el => el.classList.remove(css.active));
          e.currentTarget.classList.add(css.active);
          showQuestions();
        }}
        style={{ 
          opacity: isCompletionShown ? 0.5 : 1, 
          cursor: isCompletionShown ? 'not-allowed' : 'pointer',
          pointerEvents: isCompletionShown ? 'none' : 'auto'
        }}
      >
        {/*<img
          className={css.videoMarketing}
          src={knowlagePng}
          alt="icon"
        />*/}
        <div className={css.choiceIcon}>✓</div>
        <div className={css.choiceInfo}>
          <p className={css.textInChoice}>{t("Check Understanding")}</p>
          <p className={css.textInChoiceDesc}>{t("Test your comprehension")}</p>
        </div>
      </div>

      <div 
        className={css.choiceWrap} 
        data-choice-index="3"
        onClick={(e) => {
          if (isCompletionShown) return; // Disable when completion is shown
          document.querySelectorAll(`.${css.choiceWrap}`).forEach(el => el.classList.remove(css.active));
          e.currentTarget.classList.add(css.active);
          showDialogues();
          // Add your practice dialogues logic here
        }}
        style={{ 
          opacity: isCompletionShown ? 0.5 : 1, 
          cursor: isCompletionShown ? 'not-allowed' : 'pointer',
          pointerEvents: isCompletionShown ? 'none' : 'auto'
        }}
      >
        {/*<img
          className={css.videoMarketing}
          src={discussPng}
          alt="icon"
        />*/}
        <div className={css.choiceIcon}>💬</div>
        <div className={css.choiceInfo}>
          <p className={css.textInChoice}>{t("Practice Dialogues")}</p>
          <p className={css.textInChoiceDesc}>{t("Real-life conversations")}</p>
        </div>
      </div>
      </div>
    </div>
  );
};
export default LessonInfo;
